/*
 * @Author: mina.min
 * @Date: 2025-06-09 16:24:00
 * @LastEditors: mina.min
 * @LastEditTime: 2025-06-11 18:23:58
 * @FilePath: /OTAManagementSystem/src/pages/LogManagement/index.tsx
 * @Description:
 */
import { Typography } from 'antd'
import React from 'react'

const { Title } = Typography

const LogManagement: React.FC = () => {
  return (
    <div>
      <Title level={2}>操作日志</Title>
      <p>日志管理功能待实现...</p>
    </div>
  )
}

export default LogManagement
